import About from "./Home/About/About";
import Hero from "./Home/Hero/HeroSection";
import Navbar from "./Home/Navbar/navbar";
import Services from "./Home/Services-home/services";
import Team from "./Home/Team/team";
import Collaboration from "./Home/CollaborationSection/collaboration";
import Projects from "./Home/Projects/Projects";

function Homepage() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <About />
      <Collaboration />
      <Services />
      <Projects />
      <Team />
    </div>
  );
}

export default Homepage;
